import { Portfolio } from 'core/types/api/wms';
import { forEach } from 'lodash';

type CustomAttributes = {
    IsHidden?: boolean;
    [key: string]: any;
};

const CLOSED_PORTFOLIO_STATUS_ID = 5;

export const getActivePortfoliosIDs = (portfolios: Portfolio[]) => {
    let attributes: CustomAttributes;
    const deletedPortfolios: number[] = [];

    forEach(portfolios, (portfolio) => {
        if (portfolio.CustomAttributes) {
            attributes = JSON.parse(portfolio.CustomAttributes);

            if (attributes?.IsHidden === true || (portfolio?.PortfolioStatusId === CLOSED_PORTFOLIO_STATUS_ID && attributes?.IsRevoked === true)) {
                deletedPortfolios.push(portfolio.Id ?? 0);
            }
        }
    });

    return portfolios.map(portfolio => portfolio.Id ?? 0).filter(id => !deletedPortfolios.includes(id)) || [];
};
